const leakyRelu = require('./leaky-relu');
const relu = require('./relu');
const sigmoid = require('./sigmoid');
const tanh = require('./tanh');

module.exports = { leakyRelu, relu, sigmoid, tanh };
